(function(){
    'use strict'

    angular
    .module('app.ordenes')
    .controller('ordenes.Edit', Edit);

    Edit.$inject = ['$q', '$scope', '$animationsSrv', '$routeParams','ApiBaseService', 'logger', '$location', 'UserInfoService', 'moment'];

    function Edit($q, $scope, $animationsSrv, $routeParams, ApiBaseService, logger, $location, UserInfoService, moment) {
    
        $animationsSrv.scrollToTop();
        const apiOrdenes = 'api/Ordenes'
        const companiaId = UserInfoService.getCompaniaId();

        let vm = this;

        vm.busqueda = {
            codigo: '',
            clienteId: 0,
            proyectoId: 0
        }

        vm.data = {
            codigo: 0,
            contratoId: 0,
            clienteId: 0,
            proyectoId: 0,
            centroCostoId: 0,
            moneda:"0",
            choferId: 0,
            movilId: 0,
            aeronaveId: 0,
            estado: 1,
            fecha: moment().toDate(),
            empresaFumigadoraId: 0,
            pilotoId: 0,
            detalle: []
        };

        vm.title = 'Ordenes De Servicio';
        vm.id = $routeParams.id ? $routeParams.id : 0;

        vm.openFecha = function(){
            vm.fechaOpened = !vm.fechaOpened;
        };

        vm.clientes = [];
        vm.proyectos = [];
        vm.centrosCosto = [];
        vm.parametros = [];
        vm.contratos = [];
        vm.filterData = [];
        vm.choferes = [];
        vm.moviles = [];
        vm.aeronaves = [];
        vm.empresasFumigadoras = [];
        vm.pilotos = [];

        const promiseContratos = getComboData(vm.contratos, 'api/Contratos', [companiaId], 'Error al obtener los contratos.');
        const promiseParametros = getComboData(vm.parametros, 'api/Parametros', [companiaId], 'Error al obtener los parametros.');
        const promiseClientes = getComboData(vm.clientes, 'api/Clientes', [companiaId], 'Error al obtener los clientes.');
        const promiseChoferes = getComboData(vm.choferes, 'api/Choferes', [companiaId], 'Error al obtener los choferes.');
        const promiseMoviles = getComboData(vm.moviles, 'api/Moviles', [companiaId], 'Error al obtener las moviles.');
        const promiseAeronaves = getComboData(vm.aeronaves, 'api/Aeronaves', [companiaId], 'Error al obtener las aeronaves.');
        const promiseEmpresasFumigadoras = getComboData(vm.empresasFumigadoras, 'api/Empresas-Fumigadoras', [companiaId], 'Error al obtener las empresas fumigadoras.');

        promiseContratos.then(function(){
            vm.filterData = vm.contratos;
        });

        get();

        function getComboData(array, apiUrl, params, errorMessage){
            ApiBaseService.remoteController = apiUrl;
            var promise = ApiBaseService.getAll(params)
            .then(function(data){
                array.splice(0);
                array.push(...data);
            })
            .catch(function(error){
                $logger.error(errorMessage);
            }); 
            
            return promise;
        };

        function get(){

            $q.all([promiseClientes, promiseParametros, promiseContratos, 
                    promiseChoferes, promiseMoviles, promiseAeronaves,
                    promiseEmpresasFumigadoras])
            .then(function(){
                if(vm.id != 0){
                    ApiBaseService.remoteController = apiOrdenes;
                    var promise = ApiBaseService.getAll([companiaId, vm.id]);

                    promise
                    .then(function(data){
                        data.fecha = moment(data.fecha).toDate();
                        data.contratoId = data.contrato.id;
                        data.contratoCodigo = data.contrato.codigo;
                        data.clienteId = data.contrato.clienteId;
                        data.proyectoId = data.proyectoId;
                        data.todosLosProyectos = data.contrato.todosLosProyectos;
                        data.detalle.forEach((d)=>{
                            d.servicioNombre = d.servicio.nombre;
                            d.horaInicio = moment(d.horaInicio).toDate();
                            d.horaFin = moment(d.horaFin).toDate();
                            d.precioUnitario = d.servicio.precioUnitario;
                            d.total = d.precioUnitario * d.cantidad;
                            d.minutos = minutos(d.horaInicio, d.horaFin);
                            //d.horas = Math.floor(d.minutos / 60);
                            //d.minutosRestantes = d.minutos % 60;
                            d.unidadMedida = d.servicio.unidadMedida;
                            d.tiempoEjecutado = d.tiempoEjecutado;
                        });
                        vm.data = Object.assign(vm.data, data);
                        cargarPiloto();

                        vm.data.proyectoId = 0;

                        const promiseProyectos = getComboData(vm.proyectos, 'api/Proyectos/Cliente', [companiaId, vm.data.clienteId], 'Error al obtener los proyectos.');
                        const promiseCentrosCosto = getComboData(vm.centrosCosto, 'api/CentrosCosto/Cliente', [companiaId, vm.data.clienteId], 'Error al obtener los centros de costo.');
                        
                        promiseProyectos.then(function(){
                            vm.data.proyectoId = data.proyectoId;
                        });

                        promiseCentrosCosto.then(function(){
                            vm.data.centroCostoId = data.centroCostoId;
                        });
                    })
                    .catch(function(error){
                        switch (error.status) {
                            case 401:
                                logger.error('La sesión ha expirado');
                                break;
                        
                            default:
                                logger.error('Hubo un error al obtener el registro: ' + error.data.Message);
                                break;
                        }
                    });               
                }
                else
                {
                    var p = vm.parametros.find((p)=>p.codigo == 'PRM-1');
                    if(p)
                    {
                        vm.data.codigo = p.valor;
                    }
                }               
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al obtener los datos: ' + error.data.Message);
                        break;
                }
            }); 

        };

        function doFormValidations()
        {
            validateSelectProperty('clienteId');
            validateSelectProperty('proyectoId');
            validateSelectProperty('centroCostoId');
            validateSelectProperty('choferId');
            validateSelectProperty('movilId');
            validateSelectProperty('aeronaveId');
            validateSelectProperty('empresaFumigadoraId');
            validateSelectProperty('pilotoId');
        };

        vm.save = function(){

            $scope.submitted = true;

            if(vm.data.detalle.length == 0)
            {
                logger.error('La Orden no tiene detalle de servicios');
                return;
            }

            doFormValidations();

            if($scope.dataForm.$valid){
                if(!vm.data.id){
                    create();
                }
                else if($scope.dataForm.$dirty){
                    update();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function create() {
            vm.data.cia_codigo = companiaId;
            ApiBaseService.remoteController = apiOrdenes;

            var transform  = {
                encabezado: vm.data,
                detalle: vm.data.detalle
            };

            var promise = ApiBaseService.save(transform);
            
            promise
            .then(function(response){
                logger.success('Registro creado con éxito.');
                $location.path('/ordenes');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function update(){
            vm.data.cia_codigo = companiaId;
            ApiBaseService.remoteController = apiOrdenes;

            var transform  = {
                encabezado: vm.data,
                detalle: vm.data.detalle
            };

            var promise = ApiBaseService.update(transform);
            
            promise
            .then(function(response){
                logger.success('Registro modificado con éxito.');
                $location.path('/ordenes');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.data = {
                codigo: Number(vm.data.codigo) + 1,
                clienteId: 0,
                proyectoId: 0,
                moneda:"0",
                choferId: 0,
                movilId: 0,
                aeronaveId: 0,
                estado: 1,
                empresaFumigadoraId: 0,
                pilotoId: 0,
                centroCostoId: 0,
            };
            // Set back to pristine.
            $scope.dataForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.dataForm.$setUntouched();
        };

        function validateSelectProperty(property){
            if(vm.data[property] == 0){
                $scope.dataForm[property].$setValidity("different", false);
            }
            else{
                $scope.dataForm[property].$setValidity("different", true);
            }
        };

        vm.onSelectChanged = function(property){

            if(property == 'proyectoId')
            {
                validateSelectProperty(property);
                changeCentroCostoFromProyecto();
            }

            if(property == 'centroCostoId')
            {
                validateSelectProperty(property);
            }

            if(property == 'clienteId')
            {
                filtrarProyectos();
            }

            if(property == 'empresaFumigadoraId')
            {
                cargarPiloto();
            }
            
        };

        function filtrarProyectos()
        {
            if(vm.data.clienteId != 0)
            {
                const promiseProyectos = getComboData(vm.proyectos, 'api/Proyectos/Cliente', [companiaId, vm.data.clienteId], 'Error al obtener los proyectos.');
                const promiseCentrosCosto = getComboData(vm.centrosCosto, 'api/CentrosCosto/Cliente', [companiaId, vm.data.clienteId], 'Error al obtener los centros de costo.');
                
                promiseProyectos.then(function(){
                    vm.data.proyectoId = 0;
                });

                promiseCentrosCosto.then(function(){
                    vm.data.centroCostoId = 0;
                });
            }
        };

        function changeCentroCostoFromProyecto()
        {
            if(vm.data.proyectoId != 0)
            {
                const proyecto = vm.proyectos.find((p)=>p.id == vm.data.proyectoId);

                if(proyecto)
                {
                    vm.data.centroCostoId = proyecto.centroCostoId;
                    validateSelectProperty('centroCostoId');
                }
            }
        }

        vm.openModalBusqueda = function(){
            if(vm.contratos.length > 0){
                $('#myModalBusqueda').modal('toggle');   
            }
             
        };

        vm.filterBusqueda = function(control){

            if(control == 'clienteId')
            {
                filtrarProyectosBusqueda();
            }

            vm.filterData = vm.contratos.filter(function(g) {
                return (g.codigo.toLowerCase().indexOf(vm.busqueda.codigo.toLowerCase()) >= 0 || !vm.busqueda.codigo) && 
                (g.clienteId ==  vm.busqueda.clienteId || vm.busqueda.clienteId == 0) &&
                (g.proyectoId ==  vm.busqueda.proyectoId || vm.busqueda.proyectoId == 0);
            }).slice(0, 100);
        };

        vm.seleccionar = function(e){
            vm.data.contratoId = e.id;
            vm.data.contratoCodigo = e.codigo;
            vm.data.clienteId = e.clienteId;
            vm.data.proyectoId = e.proyectoId;
            vm.data.todosLosProyectos = e.todosLosProyectos;
            vm.data.estado = 1;

            vm.data.detalle = [];
            CargarDetalleContrato();

            vm.data.proyectoId = 0;

            const promiseProyectos = getComboData(vm.proyectos, 'api/Proyectos/Cliente', [companiaId, vm.data.clienteId], 'Error al obtener los proyectos.');
            const promiseCentrosCosto = getComboData(vm.centrosCosto, 'api/CentrosCosto/Cliente', [companiaId, vm.data.clienteId], 'Error al obtener los centros de costo.');

            promiseProyectos.then(function(){
                vm.data.proyectoId = e.proyectoId;
            });

            promiseCentrosCosto.then(function(){
                vm.data.centroCostoId = 0;
            });

            $scope.dataForm.contratoCodigo.$dirty = true;
            $scope.dataForm.$dirty = true;
            $('#myModalBusqueda').modal('toggle');   
        };

        function CargarDetalleContrato()
        {
            if(vm.id == 0)
            {
                var contrato = vm.contratos.find((c)=>c.id == vm.data.contratoId);

                if(contrato)
                {
                    if(contrato.detalle.length == 0)
                    {
                        logger.error('El contrato seleccionado no tiene detalle de servicios');
                    }
                    else
                    {
                        contrato.detalle.forEach((c)=>{
                            var ordenDetalle = {
                                id: 0,
                                cIA_Codigo: companiaId,
                                ordenServicioId: 0,
                                servicioId: c.servicioId,
                                servicioEnContratoId: c.id,
                                servicioNombre: c.nombre,
                                cantidad: 1,
                                horaInicio: moment().toDate(),
                                horaFin: moment().toDate(),
                                precioUnitario: c.precioUnitario,
                                total: c.precioUnitario,
                                minutos: 0,
                                tiempoEjecutado: 0,
                                unidadMedida: c.servicio.unidadMedida
                            }

                            vm.data.detalle.push(ordenDetalle);
                        });                        
                    }

                }
            }
        }

        function filtrarProyectosBusqueda()
        {
            vm.busqueda.proyectoId = 0;
            if(vm.busqueda.clienteId != 0)
            {
                const promiseProyectos = getComboData(vm.proyectos, 'api/Proyectos/Cliente', [companiaId, vm.busqueda.clienteId], 'Error al obtener los proyectos.');
                const promiseCentrosCosto = getComboData(vm.centrosCosto, 'api/CentrosCosto/Cliente', [companiaId, vm.data.clienteId], 'Error al obtener los centros de costo.');

                promiseProyectos.then(function(){
                    vm.busqueda.proyectoId = 0;
                });

                promiseCentrosCosto.then(function(){
                    vm.data.centroCostoId = 0;
                });
            }
        };

        vm.changedHora = function(item)
        {
            item.minutos = minutos(item.horaInicio, item.horaFin);

            //item.horas = Math.floor(item.minutos / 60);
            //item.minutosRestantes = item.minutos % 60;
        }

        vm.changedCantidad = function(item)
        {
            item.total = item.cantidad * item.precioUnitario;
        }

        function minutos(horaInicio, horafin)
        {
            return moment(horafin).diff(moment(horaInicio), 'minutes');
        }

        function cargarPiloto()
        {
            var ef = vm.empresasFumigadoras.find((e)=>e.id == vm.data.empresaFumigadoraId);

                if(ef)
                {
                    vm.pilotos = [];
                    vm.pilotos.splice(0);
                    vm.pilotos.push(...ef.pilotos);

                    var piloto = ef.pilotos.find((e)=>e.id == ef.pilotoId);

                    if(piloto)
                    {
                        vm.data.pilotoId = piloto.pilotoId.toString();
                        validateSelectProperty('pilotoId');
                    }
                }
        }

    }
})();